import { render, staticRenderFns } from "./PostPackageGroupsDatatable.vue?vue&type=template&id=e81b3c2c&scoped=true"
import script from "./PostPackageGroupsDatatable.vue?vue&type=script&lang=js"
export * from "./PostPackageGroupsDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81b3c2c",
  null
  
)

export default component.exports